import { ChangeDetectorRef, Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { Subscription } from 'rxjs';
import { RcsMessage, MessageType, CarouselCard, Suggestion, SuggestionType } from '../../../../../../_models/messaging/messages/rcs-messages/rcs-message.model';
import { ValidationService } from '../../../../../../_services/messaging/messages/rcs-messages/validation.service';
import { ListFolderDto } from 'src/app/_models/messaging/lists-and-contacts/list-folders/list-folder-dto';
import { ListFolderDtoAdapter } from 'src/app/_models/messaging/lists-and-contacts/list-folders/list-folder-dto.adapter';
import { ListFolderService } from 'src/app/_services/messaging/lists-and-contacts/list-folders/list-folder.service';
import { ListsService } from 'src/app/_services/messaging/lists-and-contacts/lists/lists.service';
import { ListModel } from 'src/app/_models/messaging/lists-and-contacts/lists/list-model';
import { ListModelAdapter } from 'src/app/_models/messaging/lists-and-contacts/lists/list-model.adapter';
import { ListFieldsModel } from 'src/app/_models/messaging/lists-and-contacts/lists/list-fields-model';
import { ListFieldsModelAdapter } from 'src/app/_models/messaging/lists-and-contacts/lists/list-fields-model.adapter';
import { SelectListOption } from 'src/app/_models/system/select-list-option';
import { ExecutionResultDto } from 'src/app/_models/execution-result-model';
import { ExecutionResult } from 'src/app/_models/execution-result-enum';
import { NotificationService } from 'src/app/_services/notification.service';
import { RcsMessageService } from '../../../../../../_services/messaging/messages/rcs-messages/rcs-message.service';
import { RcsMessageDtoRequest } from 'src/app/_models/messaging/messages/rcs-messages/rcs-message-dto-request';
import { RcsMessageDtoAdapter } from 'src/app/_models/messaging/messages/rcs-messages/rcs-message-dto.adapter';
import { SmsMessageService } from 'src/app/_services/messaging/messages/sms-messages/sms-message.service';
import { ClientInboxDto } from 'src/app/_models/admin/clients/client-inboxes-model';
import { ClientInboxAdapter } from 'src/app/_models/admin/clients/client-inboxes-model';
import { LocalStorageService } from 'src/app/_services/system/localStorage/localStorage.service';
import { MediaServerService } from 'src/app/_services/media-server/media-server.service';
import { S3ObjectsModel } from 'src/app/_models/media-server/S3Models/S3Objects.model';

@Component({
  selector: 'app-rcs-carousel',
  templateUrl: './rcs-carousel.component.html',
  styleUrls: ['./rcs-carousel.component.scss']
})
export class RcsCarouselComponent implements OnInit, OnDestroy, OnChanges {
  @Input() message: RcsMessage | null = null;
  @Output() messageChange = new EventEmitter<RcsMessage>();
  
  carousel: {
    width: 'SMALL' | 'MEDIUM';
    cards: CarouselCard[];
  } = {
    width: 'MEDIUM',
    cards: []
  };
  
  currentCardIndex: number = -1;
  editingCard: CarouselCard = {
    title: '',
    description: '',
    media: {
      url: '',
      height: 'MEDIUM'
    },
    suggestions: []
  };

  SuggestionType = SuggestionType;
  newSuggestion: Suggestion = {
    type: SuggestionType.REPLY,
    displayText: ''
  };
  carouselSuggestions: Suggestion[] = [];
  
  // Editing state for card suggestions
  editingCardSuggestionIndex: number = -1;
  editingCardSuggestion: Suggestion = {
    type: SuggestionType.REPLY,
    displayText: ''
  };
  editingCardSuggestionErrors: { [key: string]: string } = {};
  
  // Editing state for carousel suggestions
  editingCarouselSuggestionIndex: number = -1;
  editingCarouselSuggestion: Suggestion = {
    type: SuggestionType.REPLY,
    displayText: ''
  };
  editingCarouselSuggestionErrors: { [key: string]: string } = {};
  newCarouselSuggestion: Suggestion = {
    type: SuggestionType.REPLY,
    displayText: ''
  };

  // Save functionality properties
  selectedSenderId: number = 0;
  fallbackText: string = '';
  _clientInboxSelectListOptions: SelectListOption[] = [];
  fallbackTextError: string = '';
  senderError: string = '';
  fieldErrors: { [key: string]: string } = {};

  // Validation errors
  cardErrors: { [key: string]: string } = {};
  suggestionErrors: { [key: string]: string } = {};
  carouselSuggestionErrors: { [key: string]: string } = {};

  // Wildcard functionality
  @ViewChild('insertWildcardModal', { static: true }) insertWildcardModal: ModalDirective;
  @ViewChild('mediaServerModal', { static: true }) mediaServerModal: ModalDirective;
  _formGroupInsertWildcard: UntypedFormGroup;
  _listFolderSelectListOptions: SelectListOption[] = [];
  _listsSelecListOptions: SelectListOption[] = [];
  _listFieldsSelectListOptions: SelectListOption[] = [];
  _selectedListId = 0;
  _selectedListFieldId = 0;
  _selectedListFolderId = 0;
  _wildcardTarget: 'title' | 'description' | 'fallback' = 'title';
  _selectionStart = 0;
  _showSpinner = false;
  _showMediaServer = false;
  _mediaServerTarget: 'media' | 'thumbnail' = 'media';
  _subscriptionListFolders: Subscription;
  _subscriptionLists: Subscription;
  _subscriptionListFields: Subscription;

  constructor(
    private cdr: ChangeDetectorRef,
    private validationService: ValidationService,
    private listFolderService: ListFolderService,
    private listFolderDtoAdapter: ListFolderDtoAdapter,
    private listsService: ListsService,
    private listModelAdapter: ListModelAdapter,
    private listFieldsModelAdapter: ListFieldsModelAdapter,
    private notificationService: NotificationService,
    private rcsMessageService: RcsMessageService,
    private rcsMessageDtoAdapter: RcsMessageDtoAdapter,
    private smsMessageService: SmsMessageService,
    private clientInboxAdapter: ClientInboxAdapter,
    private localStorageService: LocalStorageService,
    private mediaServerService: MediaServerService
  ) {}

  ngOnInit(): void {
    this.initWildcardForm();
    this.populateListFoldersDropdown();    
    this.subscribeToWildcardFormControls();
    this.populateSendersDropdown();

    // IMPORTANT: Don't initialize carousel here! 
    // Carousel is initialized in ngOnChanges when @Input message arrives
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['message'] && changes['message'].currentValue) {
      const message = changes['message'].currentValue as RcsMessage;
      const previousIndex = this.currentCardIndex;
      
      if (message.carousel) {
        this.carousel = { ...message.carousel };
        if (this.carousel.cards.length > 0) {
          // Preserve selected card if possible; otherwise fallback to first
          this.currentCardIndex = Math.min(
            Math.max(previousIndex, 0),
            this.carousel.cards.length - 1
          );
          this.editingCard = { ...this.carousel.cards[this.currentCardIndex] };
          if (!this.editingCard.media) {
            this.editingCard.media = { url: '', height: 'MEDIUM' };
          }
        } else {
          // If carousel exists but has no cards, add two empty cards for create mode (minimum required)
          this.addNewCard();
          this.addNewCard();
        }
      }
      
      if (message.suggestions) {
        this.carouselSuggestions = [...message.suggestions];
      }
      
      if (message.fallbackText) {
        this.fallbackText = message.fallbackText;
      }
      
      if (message.fallbackSenderId) {
        this.selectedSenderId = parseInt(message.fallbackSenderId) || 0;
      }
      
      // Don't call onCarouselChange() here - only populate form from @Input data
      // User interactions will call onCarouselChange()
    }
  }

  ngOnDestroy(): void {
    this._subscriptionListFolders?.unsubscribe();
    this._subscriptionLists?.unsubscribe();
    this._subscriptionListFields?.unsubscribe();
    // Do NOT call resetForm() here — it emits a CAROUSEL message which would
    // overwrite the parent's currentMessage after the active type has already changed,
    // causing the preview and other type components to receive stale carousel data.
  }

  onCarouselChange(): void {
    const updatedMessage: RcsMessage = {
      type: MessageType.CAROUSEL,
      carousel: { ...this.carousel },
      suggestions: this.carouselSuggestions.length > 0 ? [...this.carouselSuggestions] : undefined,
      fallbackText: this.fallbackText,
      fallbackSenderId: this.selectedSenderId ? this.selectedSenderId.toString() : undefined,
      timestamp: new Date()
    };
    this.messageChange.emit(updatedMessage);
  }

  addNewCard(): void {
    const newCard: CarouselCard = {
      title: '',
      description: '',
      media: {
        url: '',
        height: 'MEDIUM'
      },
      suggestions: []
    };
    this.carousel.cards.push(newCard);
    this.currentCardIndex = this.carousel.cards.length - 1;
    this.editingCard = { ...newCard };
    if (!this.editingCard.media) {
      this.editingCard.media = { url: '', height: 'MEDIUM' };
    }
    this.cardErrors = {};
    this.onCarouselChange();
  }

  selectCard(index: number): void {
    this.currentCardIndex = index;
    this.editingCard = { ...this.carousel.cards[index] };
    if (!this.editingCard.media) {
      this.editingCard.media = { url: '', height: 'MEDIUM' };
    }
    this.cardErrors = {};
  }

  updateCurrentCard(): void {
    if (this.currentCardIndex >= 0 && this.currentCardIndex < this.carousel.cards.length) {
      this.carousel.cards[this.currentCardIndex] = { ...this.editingCard };
      this.onCarouselChange();
    }
  }

  removeCard(index: number): void {
    if (this.carousel.cards.length > 1) {
      this.carousel.cards.splice(index, 1);
      if (this.currentCardIndex >= this.carousel.cards.length) {
        this.currentCardIndex = this.carousel.cards.length - 1;
      }
      if (this.currentCardIndex >= 0) {
        this.editingCard = { ...this.carousel.cards[this.currentCardIndex] };
        if (!this.editingCard.media) {
          this.editingCard.media = { url: '', height: 'MEDIUM' };
        }
      }
      this.onCarouselChange();
    }
  }

  populateSendersDropdown(): void {
    this.smsMessageService.getClientInboxes().subscribe((executionResultDto: ExecutionResultDto) => {
      this._showSpinner = true;

      if (executionResultDto.executionResult === ExecutionResult.success) {
        const clientInboxDtos = executionResultDto.data
          .map((clientInboxDto: ClientInboxDto) => this.clientInboxAdapter.adapt(clientInboxDto));

        this._clientInboxSelectListOptions = clientInboxDtos.map((clientInboxDto: ClientInboxDto) =>
          new SelectListOption(clientInboxDto.id, `(${clientInboxDto.InboxNumber}) ${clientInboxDto.InboxName}`));
      } else {
        this.notificationService.showError(executionResultDto.message);
      }
      this._showSpinner = false;
    }, error => this._showSpinner = false);
  }

  onFallbackTextChange(): void {
    this.validateFallbackText();
    this.onCarouselChange();
  }

  onSenderChange(): void {
    if (this.selectedSenderId === 0) {
      this.senderError = 'Please select a sender';
    } else {
      this.senderError = '';
    }
    this.onCarouselChange();
  }

  onCardFieldChange(): void {
    this.cardErrors = {};
    this.updateCurrentCard();
  }

  validateCardField(field: string, value: any): void {
    this.cardErrors[field] = '';

    if (field === 'title' && value) {
      const profanityCheck = this.validationService.validateTextForProfanity(value);
      if (!profanityCheck.valid) {
        this.cardErrors['title'] = profanityCheck.error || '';
      }
    } else if (field === 'description' && value) {
      const profanityCheck = this.validationService.validateTextForProfanity(value);
      if (!profanityCheck.valid) {
        this.cardErrors['description'] = profanityCheck.error || '';
      }
    } else if (field === 'mediaUrl') {
      if (!value || !value.trim()) {
        this.cardErrors['mediaUrl'] = 'Media URL is required';
      } else {
        const urlCheck = this.validationService.validateUrl(value);
        if (!urlCheck.valid) {
          this.cardErrors['mediaUrl'] = urlCheck.error || '';
        }
      }
    } else if (field === 'thumbnailUrl' && value) {
      const urlCheck = this.validationService.validateUrl(value);
      if (!urlCheck.valid) {
        this.cardErrors['thumbnailUrl'] = urlCheck.error || '';
      }
    }
  }

  onMediaUrlChange(): void {
    if (!this.editingCard.media) {
      this.editingCard.media = { url: '', height: 'MEDIUM' };
    }
    this.validateCardField('mediaUrl', this.editingCard.media.url);
    this.updateCurrentCard();
  }

  openMediaServerModal(target: 'media' | 'thumbnail'): void {
    this._mediaServerTarget = target;
    this._showMediaServer = true;
    this.mediaServerService.selectedFiles = [];
    this.mediaServerModal.show();
  }

  onMediaLoadError(field: 'mediaUrl' | 'thumbnailUrl'): void {
    this.cardErrors[field] = 'Failed to load image from URL';
  }

  applyMediaFromServer(): void {
    const files: S3ObjectsModel[] = this.mediaServerService.selectedFiles;

    if (!files || files.length === 0) {
      this.notificationService.showWarning('Please select a file to insert.');
      return;
    }

    const selectedFile = files[0];
    const publicUrl = this.mediaServerService.getFilePublicUrl(selectedFile);

    if (!publicUrl || publicUrl === 'N/A') {
      this.notificationService.showWarning('Selected file type is not supported for RCS carousel cards.');
      return;
    }

    if (this._mediaServerTarget === 'media') {
      if (!this.editingCard.media) {
        this.editingCard.media = { url: '', height: 'MEDIUM' };
      }
      this.editingCard.media.url = publicUrl;
      this.onMediaUrlChange();
    } else {
      this.editingCard.thumbnail = this.editingCard.thumbnail || { url: '', height: 'MEDIUM' };
      this.editingCard.thumbnail.url = publicUrl;
      this.validateCardField('thumbnailUrl', this.editingCard.thumbnail.url);
      this.onCardFieldChange();
    }

    this.closeMediaServer();
  }

  closeMediaServer(): void {
    this._showMediaServer = false;
    this.mediaServerService.selectedFiles = [];
    this._mediaServerTarget = 'media';
    this.mediaServerModal.hide();
  }

  addSuggestion(): void {
    const result = this.validationService.validateSuggestion(this.newSuggestion);
    this.suggestionErrors = { ...result.errors };
    if (!result.valid) {
      this.cdr.detectChanges();
      return;
    }

    this.editingCard.suggestions = this.editingCard.suggestions || [];
    this.editingCard.suggestions.push({ ...this.newSuggestion });
    this.resetNewSuggestion();
    this.updateCurrentCard();
  }

  removeSuggestion(index: number): void {
    if (this.editingCard.suggestions) {
      this.editingCard.suggestions.splice(index, 1);
      this.updateCurrentCard();
    }
  }

  editCardSuggestion(index: number): void {
    if (this.editingCard.suggestions && this.editingCard.suggestions[index]) {
      this.editingCardSuggestionIndex = index;
      this.editingCardSuggestion = { ...this.editingCard.suggestions[index] };
      this.editingCardSuggestionErrors = {};
    }
  }

  saveEditingCardSuggestion(): void {
    const result = this.validationService.validateSuggestion(this.editingCardSuggestion);
    this.editingCardSuggestionErrors = { ...result.errors };
    if (!result.valid) {
      this.cdr.detectChanges();
      return;
    }

    if (this.editingCard.suggestions) {
      this.editingCard.suggestions[this.editingCardSuggestionIndex] = { ...this.editingCardSuggestion };
    }
    this.cancelEditingCardSuggestion();
    this.updateCurrentCard();
  }

  cancelEditingCardSuggestion(): void {
    this.editingCardSuggestionIndex = -1;
    this.editingCardSuggestion = {
      type: SuggestionType.REPLY,
      displayText: ''
    };
    this.editingCardSuggestionErrors = {};
  }

  onEditingCardSuggestionTypeChange(): void {
    // Reset type-specific fields when type changes
    this.editingCardSuggestion.url = undefined;
    this.editingCardSuggestion.phone = undefined;
    this.editingCardSuggestion.address = undefined;
    this.editingCardSuggestion.latitude = undefined;
    this.editingCardSuggestion.longitude = undefined;
    this.editingCardSuggestion.meetingTitle = undefined;
    this.editingCardSuggestion.meetingDescription = undefined;
    this.editingCardSuggestion.startTime = undefined;
    this.editingCardSuggestion.endTime = undefined;
    this.editingCardSuggestionErrors = {};
  }

  onSuggestionTypeChange(): void {
    this.newSuggestion.url = undefined;
    this.newSuggestion.phone = undefined;
    this.newSuggestion.address = undefined;
    this.newSuggestion.latitude = undefined;
    this.newSuggestion.longitude = undefined;
    this.newSuggestion.startTime = undefined;
    this.newSuggestion.endTime = undefined;
    this.newSuggestion.meetingTitle = undefined;
    this.newSuggestion.meetingDescription = undefined;
    this.suggestionErrors = {};
  }

  validateSuggestionField(field: string, value: any): void {
    const suggestion = { ...this.newSuggestion, [field]: value };
    const result = this.validationService.validateSuggestionField(suggestion, field);
    if (result.valid) {
      delete this.suggestionErrors[field];
    } else {
      this.suggestionErrors[field] = result.error || '';
    }
    this.cdr.detectChanges();
  }

  resetNewSuggestion(): void {
    this.newSuggestion = {
      type: SuggestionType.REPLY,
      displayText: ''
    };
    this.suggestionErrors = {};
  }

  addCarouselSuggestion(): void {
    const result = this.validationService.validateSuggestion(this.newCarouselSuggestion);
    this.carouselSuggestionErrors = { ...result.errors };
    if (!result.valid) {
      this.cdr.detectChanges();
      return;
    }

    this.carouselSuggestions.push({ ...this.newCarouselSuggestion });
    this.resetNewCarouselSuggestion();
    this.onCarouselChange();
  }

  removeCarouselSuggestion(index: number): void {
    this.carouselSuggestions.splice(index, 1);
    this.onCarouselChange();
  }

  editCarouselSuggestion(index: number): void {
    if (this.carouselSuggestions[index]) {
      this.editingCarouselSuggestionIndex = index;
      this.editingCarouselSuggestion = { ...this.carouselSuggestions[index] };
      this.editingCarouselSuggestionErrors = {};
    }
  }

  saveEditingCarouselSuggestion(): void {
    const result = this.validationService.validateSuggestion(this.editingCarouselSuggestion);
    this.editingCarouselSuggestionErrors = { ...result.errors };
    if (!result.valid) {
      this.cdr.detectChanges();
      return;
    }

    this.carouselSuggestions[this.editingCarouselSuggestionIndex] = { ...this.editingCarouselSuggestion };
    this.cancelEditingCarouselSuggestion();
    this.onCarouselChange();
  }

  cancelEditingCarouselSuggestion(): void {
    this.editingCarouselSuggestionIndex = -1;
    this.editingCarouselSuggestion = {
      type: SuggestionType.REPLY,
      displayText: ''
    };
    this.editingCarouselSuggestionErrors = {};
  }

  onEditingCarouselSuggestionTypeChange(): void {
    // Reset type-specific fields when type changes
    this.editingCarouselSuggestion.url = undefined;
    this.editingCarouselSuggestion.phone = undefined;
    this.editingCarouselSuggestion.address = undefined;
    this.editingCarouselSuggestion.latitude = undefined;
    this.editingCarouselSuggestion.longitude = undefined;
    this.editingCarouselSuggestion.meetingTitle = undefined;
    this.editingCarouselSuggestion.meetingDescription = undefined;
    this.editingCarouselSuggestion.startTime = undefined;
    this.editingCarouselSuggestion.endTime = undefined;
    this.editingCarouselSuggestionErrors = {};
  }

  onCarouselSuggestionTypeChange(): void {
    this.newCarouselSuggestion.url = undefined;
    this.newCarouselSuggestion.phone = undefined;
    this.newCarouselSuggestion.address = undefined;
    this.newCarouselSuggestion.latitude = undefined;
    this.newCarouselSuggestion.longitude = undefined;
    this.newCarouselSuggestion.startTime = undefined;
    this.newCarouselSuggestion.endTime = undefined;
    this.newCarouselSuggestion.meetingTitle = undefined;
    this.newCarouselSuggestion.meetingDescription = undefined;
    this.carouselSuggestionErrors = {};
  }

  validateCarouselSuggestionField(field: string, value: any): void {
    const suggestion = { ...this.newCarouselSuggestion, [field]: value };
    const result = this.validationService.validateSuggestionField(suggestion, field);
    if (result.valid) {
      delete this.carouselSuggestionErrors[field];
    } else {
      this.carouselSuggestionErrors[field] = result.error || '';
    }
    this.cdr.detectChanges();
  }

  resetNewCarouselSuggestion(): void {
    this.newCarouselSuggestion = {
      type: SuggestionType.REPLY,
      displayText: ''
    };
    this.carouselSuggestionErrors = {};
  }

  initWildcardForm(): void {
    this._formGroupInsertWildcard = new UntypedFormGroup({
      listFolders: new UntypedFormControl({ value: 0, disabled: true }, Validators.required),
      lists: new UntypedFormControl({ value: 0, disabled: true }, Validators.required),
      listFields: new UntypedFormControl({ value: 0, disabled: true }, Validators.required)
    });
  }

  rememberSelection(event: any, target: 'title' | 'description' | 'fallback'): void {
    if (event?.target?.selectionStart !== undefined) {
      this._selectionStart = event.target.selectionStart;
    }
    this._wildcardTarget = target;
  }

  openWildcard(target: 'title' | 'description' | 'fallback', inputEl: HTMLInputElement | HTMLTextAreaElement): void {
    this._wildcardTarget = target;
    this._selectionStart = inputEl?.selectionStart || 0;
    this._formGroupInsertWildcard.reset({ listFolders: 0, lists: 0, listFields: 0 });
    this.insertWildcardModal.show();
  }

  insertWildcardModalSubmit(): void {
    const field = this._listFieldsSelectListOptions.find(x => x.value === this._selectedListFieldId)?.simpleName || '';
    const targetValue = this._wildcardTarget === 'title'
      ? this.editingCard.title
      : this._wildcardTarget === 'description'
        ? this.editingCard.description
        : this.fallbackText;
    const before = targetValue.substring(0, this._selectionStart);
    const after = targetValue.substring(this._selectionStart);
    const withWildcard = `${before}${field}${after}`;

    if (this._wildcardTarget === 'title') {
      this.editingCard.title = withWildcard;
      this.onCardFieldChange();
    } else if (this._wildcardTarget === 'description') {
      this.editingCard.description = withWildcard;
      this.onCardFieldChange();
    } else {
      this.fallbackText = withWildcard;
      this.onFallbackTextChange();
    }

    this.insertWildcardModal.hide();
  }

  subscribeToWildcardFormControls(): void {
    this._subscriptionListFolders = this._formGroupInsertWildcard.get('listFolders')?.valueChanges.subscribe(folderId => {
      this._selectedListFolderId = folderId;
      this.populateListsDropdown();
    });
    this._subscriptionLists = this._formGroupInsertWildcard.get('lists')?.valueChanges.subscribe(listId => {
      this._selectedListId = listId;
      this.populateListFieldsDropdown();
    });
    this._subscriptionListFields = this._formGroupInsertWildcard.get('listFields')?.valueChanges.subscribe(listFieldId => {
      this._selectedListFieldId = listFieldId;
    });
  }

  populateListFoldersDropdown(): void {
    this._showSpinner = true;
    this._formGroupInsertWildcard.get('listFolders')?.disable();

    this.listFolderService.getAll().subscribe((executionResultDto: ExecutionResultDto) => {
      if (executionResultDto.executionResult === ExecutionResult.success) {
        const listFolderDtos = executionResultDto.data
          .map((dto: ListFolderDto) => this.listFolderDtoAdapter.adapt(dto));

        this._listFolderSelectListOptions = listFolderDtos.map((dto: ListFolderDto) =>
          new SelectListOption(dto.id, dto.name));
      } else {
        this.notificationService.showError(executionResultDto.message);
      }
      this._showSpinner = false;
      this._formGroupInsertWildcard.get('listFolders')?.enable();
    }, () => {
      this._showSpinner = false;
      this._formGroupInsertWildcard.get('listFolders')?.enable();
    });
  }

  populateListsDropdown(): void {
    if (!this._selectedListFolderId) { return; }

    this._showSpinner = true;
    this._formGroupInsertWildcard.get('lists')?.disable();

    this.listsService.getByFolderId(this._selectedListFolderId).subscribe((executionResultDto: ExecutionResultDto) => {
      if (executionResultDto.executionResult === ExecutionResult.success) {
        const listDtos = executionResultDto.data
          .map((dto: ListModel) => this.listModelAdapter.adapt(dto));

        this._listsSelecListOptions = listDtos.map((dto: ListModel) =>
          new SelectListOption(dto.ListID, dto.ListName));

        this._selectedListId = this._listsSelecListOptions.length === 1 ? this._listsSelecListOptions[0].value : 0;
        this._formGroupInsertWildcard.get('lists')?.setValue(this._selectedListId);
      } else {
        this.notificationService.showError(executionResultDto.message);
      }
      this._showSpinner = false;
      this._formGroupInsertWildcard.get('lists')?.enable();
    }, () => {
      this._showSpinner = false;
      this._formGroupInsertWildcard.get('lists')?.enable();
    });
  }

  populateListFieldsDropdown(): void {
    if (!this._selectedListId) { return; }

    this._showSpinner = true;
    this._formGroupInsertWildcard.get('listFields')?.disable();

    this.listsService.getWildcardListFields(this._selectedListId).subscribe((executionResultDto: ExecutionResultDto) => {
      if (executionResultDto.executionResult === ExecutionResult.success) {
        const listFieldDtos = executionResultDto.data
          .map((dto: ListFieldsModel) => this.listFieldsModelAdapter.adapt(dto));

        this._listFieldsSelectListOptions = listFieldDtos.map((dto: ListFieldsModel) => {
          const label = dto.FieldName || dto.DisplayName;
          return new SelectListOption(dto.FieldID, label, dto.Wildcard);
        });

        this._selectedListFieldId = this._listFieldsSelectListOptions.length === 1
          ? this._listFieldsSelectListOptions[0].value
          : 0;

        this._formGroupInsertWildcard.get('listFields')?.setValue(this._selectedListFieldId);
      } else {
        this.notificationService.showError(executionResultDto.message);
      }
      this._showSpinner = false;
      this._formGroupInsertWildcard.get('listFields')?.enable();
    }, () => {
      this._showSpinner = false;
      this._formGroupInsertWildcard.get('listFields')?.enable();
    });
  }

  save(messageId: number = 0, messageName: string = '', folderId: number = 0): Promise<number> {
    return new Promise((resolve, reject) => {
      this.validateAll();
      
      if (this.hasValidationErrors()) {
        this.notificationService.showError('Please fix validation errors before saving');
        reject(new Error('Validation errors'));
        return;
      }

    const rcsContentJson = JSON.stringify({
      type: 'carousel',
      carousel: {
        width: this.carousel.width,
        cards: this.carousel.cards.map(card => ({
          title: card.title,
          description: card.description,
          media: card.media,
          thumbnail: card.thumbnail
        }))
      }
    });

    // Combine carousel-level suggestions and card-level suggestions
    const allSuggestions = [
      // Carousel-level suggestions (message scope)
      ...this.carouselSuggestions.map(s => ({
        type: s.type,
        displayText: s.displayText,
        SuggestionScope: 'global',
        url: s.url,
        phone: s.phone,
        address: s.address,
        latitude: s.latitude,
        longitude: s.longitude,
        startTime: s.startTime,
        endTime: s.endTime,
        meetingTitle: s.meetingTitle,
        meetingDescription: s.meetingDescription
      })),
      // Card-level suggestions (card scope)
      ...this.carousel.cards.reduce((acc: any[], card, cardIndex) => {
        const cardSugs = (card.suggestions || []).map(s => ({
          type: s.type,
          displayText: s.displayText,
          SuggestionScope: 'card',
          CardIndex: cardIndex,
          url: s.url,
          phone: s.phone,
          address: s.address,
          latitude: s.latitude,
          longitude: s.longitude,
          startTime: s.startTime,
          endTime: s.endTime,
          meetingTitle: s.meetingTitle,
          meetingDescription: s.meetingDescription
        }));
        return acc.concat(cardSugs);
      }, [])
    ];

    const rcsMessageDtoRequest = new RcsMessageDtoRequest({
      id: messageId,
      folderId: folderId,
      name: messageName,
      rcsType: 'carousel',
      rcsContentJson: rcsContentJson,
      suggestions: allSuggestions,
      smsFallbackEnabled: true,
      smsFallbackText: this.fallbackText,
      smsFallbackClientInboxId: this.selectedSenderId,
    });

    this._showSpinner = true;

      this.rcsMessageService.save(rcsMessageDtoRequest).subscribe((executionResultDto: ExecutionResultDto) => {
        if (executionResultDto.executionResult === ExecutionResult.success) {
          const rcsMessageDto = this.rcsMessageDtoAdapter.adapt(executionResultDto.data);
          this.notificationService.showSuccess('RCS Carousel saved successfully');
          this.messageChange.emit({
            ...this.message,
            carousel: this.carousel,
            suggestions: this.carouselSuggestions
          });
          resolve(rcsMessageDto.messageId || messageId);
        } else {
          this.notificationService.showError(executionResultDto.message);
          reject(new Error(executionResultDto.message));
        }
        this._showSpinner = false;
      }, error => {
        this.notificationService.showError('Error saving RCS Carousel');
        this._showSpinner = false;
        reject(error);
      });
    });
  }

  private hasValidationErrors(): boolean {
    return !!(Object.keys(this.fieldErrors).length > 0 ||
      Object.keys(this.cardErrors).length > 0 ||
      Object.keys(this.carouselSuggestionErrors).length > 0 ||
      this.fallbackTextError || this.senderError);
  }

  private validateAll(): void {
    this.fieldErrors = {};
    this.cardErrors = {};
    this.carouselSuggestionErrors = {};
    this.fallbackTextError = '';
    this.senderError = '';

    // Validate carousel card count (2-10 cards required)
    if (this.carousel.cards.length < 2) {
      this.cardErrors['cards'] = 'At least 2 cards are required for a carousel';
      return;
    }
    if (this.carousel.cards.length > 10) {
      this.cardErrors['cards'] = 'Maximum 10 cards allowed in a carousel';
      return;
    }

    // Validate each card
    this.carousel.cards.forEach((card, index) => {
      if (!card.title?.trim()) {
        this.cardErrors[`card-${index}-title`] = `Card ${index + 1} title is required`;
        if (index === this.currentCardIndex) {
          this.cardErrors['title'] = 'Title is required';
        }
      }
      if (!card.description?.trim()) {
        this.cardErrors[`card-${index}-description`] = `Card ${index + 1} description is required`;
        if (index === this.currentCardIndex) {
          this.cardErrors['description'] = 'Description is required';
        }
      }
      if (!card.media?.url?.trim()) {
        this.cardErrors[`card-${index}-media`] = `Card ${index + 1} media URL is required`;
        if (index === this.currentCardIndex) {
          this.cardErrors['mediaUrl'] = 'Media URL is required';
        }
      }
    });

    // Validate carousel-level suggestions
    this.carouselSuggestions.forEach((suggestion, index) => {
      if (!suggestion.displayText?.trim()) {
        this.carouselSuggestionErrors[`suggestion-${index}-displayText`] = `Carousel suggestion ${index + 1} display text is required`;
      }
    });

    // Validate fallback text and sender
    this.validateFallbackText();
    this.validateSender();
  }

  validateFallbackText(): void {
    this.fallbackTextError = '';
    if (!this.fallbackText || this.fallbackText.trim() === '') {
      this.fallbackTextError = 'Fallback text is required';
      return;
    }
    const profanityCheck = this.validationService.validateTextForProfanity(this.fallbackText);
    if (!profanityCheck.valid) {
      this.fallbackTextError = profanityCheck.error || '';
    }
  }

  private validateSender(): void {
    this.senderError = '';
    if (!this.selectedSenderId || this.selectedSenderId === 0) {
      this.senderError = 'Please select a sender';
    }
  }

  load(messageId: number): void {
    if (messageId <= 0) {
      return;
    }

    this._showSpinner = true;
    this.rcsMessageService.get(messageId).subscribe((executionResultDto: ExecutionResultDto) => {
      if (executionResultDto.executionResult === ExecutionResult.success) {
        const rcsMessageDto = this.rcsMessageDtoAdapter.adapt(executionResultDto.data);
        this.loadFromRcsMessage(rcsMessageDto);
      } else {
        this.notificationService.showError(executionResultDto.message || 'Failed to load RCS message');
      }
      this._showSpinner = false;
    }, error => {
      this.notificationService.showError('Error loading RCS message');
      this._showSpinner = false;
      console.error('Error loading RCS message:', error);
    });
  }

  private loadFromRcsMessage(rcsMessageDto: any): void {
    try {
      const contentJsonStr = rcsMessageDto.rcsContentJson || rcsMessageDto.RCSContentJson;
      const rcsContent = JSON.parse(contentJsonStr);
      const suggestionsFromDto = (rcsMessageDto.Suggestions || rcsMessageDto.suggestions || []) as any[];
      
      if (rcsContent.type === 'carousel') {
        const carouselContent = rcsContent.carousel || rcsContent.Carousel || {};
        const cardsFromContent = carouselContent.cards || carouselContent.Cards || [];
        this.carousel = {
          width: carouselContent.width || carouselContent.Width || 'MEDIUM',
          cards: cardsFromContent.map((card: any) => ({
            title: card.title || card.Title || '',
            description: card.description || card.Description || '',
            media: card.media || card.Media || { url: '', height: 'MEDIUM' },
            thumbnail: card.thumbnail || card.Thumbnail,
            suggestions: []
          }))
        };
        console.debug('[RCS][Carousel] mapped carousel', this.carousel);
      }
      
      // Map suggestions from DTO (they are stored separately server-side)
      this.carouselSuggestions = suggestionsFromDto
        .filter(s => (s.SuggestionScope || s.suggestionScope || '').toLowerCase() === 'global')
        .map(s => ({
          type: (s.Type || s.type || '').toString() as any,
          displayText: s.DisplayText || s.displayText || '',
          url: s.Url || s.url,
          phone: s.Phone || s.phone,
          address: s.Address || s.address,
          latitude: s.Latitude ?? s.latitude,
          longitude: s.Longitude ?? s.longitude,
          startTime: s.StartTime || s.startTime,
          endTime: s.EndTime || s.endTime,
          meetingTitle: s.MeetingTitle || s.meetingTitle,
          meetingDescription: s.MeetingDescription || s.meetingDescription
        }));
      console.debug('[RCS][Carousel] mapped global suggestions', this.carouselSuggestions);

      const cardScopedSuggestions = suggestionsFromDto
        .filter(s => (s.SuggestionScope || s.suggestionScope || '').toLowerCase() === 'card');

      cardScopedSuggestions.forEach(s => {
        const cardIndex = s.CardIndex ?? s.cardIndex;
        if (cardIndex === undefined || cardIndex === null) return;
        if (!this.carousel.cards[cardIndex]) return;
        this.carousel.cards[cardIndex].suggestions = this.carousel.cards[cardIndex].suggestions || [];
        this.carousel.cards[cardIndex].suggestions.push({
          type: (s.Type || s.type || '').toString() as any,
          displayText: s.DisplayText || s.displayText || '',
          url: s.Url || s.url,
          phone: s.Phone || s.phone,
          address: s.Address || s.address,
          latitude: s.Latitude ?? s.latitude,
          longitude: s.Longitude ?? s.longitude,
          startTime: s.StartTime || s.startTime,
          endTime: s.EndTime || s.endTime,
          meetingTitle: s.MeetingTitle || s.meetingTitle,
          meetingDescription: s.MeetingDescription || s.meetingDescription
        });
      });
      
      // Set current card if available
      if (this.carousel.cards.length > 0) {
        this.currentCardIndex = 0;
        this.editingCard = { ...this.carousel.cards[0] };
        if (!this.editingCard.media) {
          this.editingCard.media = { url: '', height: 'MEDIUM' };
        }
        if (!this.editingCard.suggestions) {
          this.editingCard.suggestions = [];
        }
      }
      
      this.fallbackText = rcsMessageDto.smsFallbackText || '';
      this.selectedSenderId = rcsMessageDto.smsFallbackClientInboxId || 0;
      
      this.onCarouselChange();
    } catch (error) {
      this.notificationService.showError('Invalid message format');
      console.error('Load error', error);
    }
  }

  resetForm(): void {
    // Reset carousel data
    this.carousel = {
      width: 'MEDIUM',
      cards: [{
        title: '',
        description: '',
        media: {
          url: '',
          height: 'MEDIUM'
        },
        suggestions: []
      }]
    };
    
    // Reset carousel suggestions
    this.carouselSuggestions = [];
    
    // Reset fallback text
    this.fallbackText = '';
    this.selectedSenderId = 0;
    
    // Clear errors
    this.fieldErrors = {};
    this.cardErrors = {};
    this.carouselSuggestionErrors = {};
    this.fallbackTextError = '';
    this.senderError = '';
    
    // Reset message
    this.message = {
      type: MessageType.CAROUSEL,
      carousel: this.carousel,
      suggestions: this.carouselSuggestions,
      fallbackText: '',
      fallbackSenderId: undefined
    };
    
    // Emit reset message to parent
    this.messageChange.emit(this.message);
    this.onCarouselChange();
  }

}
